import type { AgendaItemDto } from "@/repositories/agendaItemRepo";
import React, { createContext, useContext } from "react";

export const AgendaItemDefaultsContext = createContext<{
  defaults: Partial<AgendaItemDto>;
  showPending: boolean;
} | null>(null);

export const AgendaItemDefaults = ({
  defaults,
  children,
  showPending,
}: {
  defaults: Partial<AgendaItemDto>;
  children?: React.ReactNode;
  showPending?: boolean;
}) => {
  const prevContext = useContext(AgendaItemDefaultsContext);
  const nextDefaults = { ...prevContext?.defaults, ...defaults };
  if (showPending == null) showPending ??= prevContext?.showPending ?? true;

  return (
    <AgendaItemDefaultsContext.Provider
      value={{ defaults: nextDefaults, showPending }}
    >
      {children}
    </AgendaItemDefaultsContext.Provider>
  );
};
